import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  width: 100%;
  padding: 12px 0;

  @media (max-width: 480px) {
    flex-wrap: wrap-reverse;
    justify-content: center;
    gap: 12px;
  }
`;

export const PageSizeBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
